/**
 * Mock data for Contratos page.
 * Uses the same contract numbers and clients as Central de Notas mock.
 */

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type ContratoStatus = 'ativo' | 'encerrado' | 'em-negociacao'
export type FormaRemuneracao = 'Fee Mensal' | 'Success Fee' | 'Misto' | 'Projeto'

export interface Aditivo {
  id: string
  numero: string
  data: string            // ISO date
  descricao: string
  valorAdicional?: number // se o aditivo aumentou o limite
  pdfUrl?: string
}

export interface Contrato {
  id: string
  cliente: string
  numero: string
  periodo: {
    inicio: string        // ISO date
    fim: string           // ISO date
  }
  valorLimite: number
  agenciasEnvolvidas: number       // nº de agências que dividem o contrato
  formaRemuneracao: FormaRemuneracao
  percentuaisRemuneracao?: {
    fee?: number
    success?: number
    bonus?: number
  }
  dataRepactuacao: string | null
  aditivos: Aditivo[]
  pdfUrl?: string
  status: ContratoStatus
}

// ---------------------------------------------------------------------------
// Mock contracts — mesmos números de CONTRATOS da Central de Notas
// ---------------------------------------------------------------------------

export const MOCK_CONTRATOS: Contrato[] = [
  {
    id: 'ctr-1',
    cliente: 'Petrobras',
    numero: '0054',
    periodo: { inicio: '2025-07-01', fim: '2026-07-01' },
    valorLimite: 4_800_000,
    agenciasEnvolvidas: 2,
    formaRemuneracao: 'Fee Mensal',
    percentuaisRemuneracao: { fee: 100 },
    dataRepactuacao: '2026-05-01',
    aditivos: [
      {
        id: 'adit-1',
        numero: '0054-A1',
        data: '2025-10-15',
        descricao: 'Inclusao de escopo digital — campanha institucional Q4',
        valorAdicional: 600_000,
      },
    ],
    status: 'ativo',
  },
  {
    id: 'ctr-2',
    cliente: 'Banco do Brasil',
    numero: '15/19',
    periodo: { inicio: '2025-01-01', fim: '2025-12-31' },
    valorLimite: 3_200_000,
    agenciasEnvolvidas: 3,
    formaRemuneracao: 'Misto',
    percentuaisRemuneracao: { fee: 70, success: 30 },
    dataRepactuacao: '2025-10-01',
    aditivos: [],
    status: 'ativo',
  },
  {
    id: 'ctr-3',
    cliente: 'Vale',
    numero: '25/54',
    periodo: { inicio: '2025-04-01', fim: '2026-03-31' },
    valorLimite: 5_500_000,
    agenciasEnvolvidas: 2,
    formaRemuneracao: 'Fee Mensal',
    percentuaisRemuneracao: { fee: 85, bonus: 15 },
    dataRepactuacao: '2026-01-15',
    aditivos: [
      {
        id: 'adit-2',
        numero: '25/54-A1',
        data: '2025-08-01',
        descricao: 'Aditivo de produccao grafica para eventos presenciais',
        valorAdicional: 450_000,
      },
      {
        id: 'adit-3',
        numero: '25/54-A2',
        data: '2025-12-10',
        descricao: 'Extensao de prazo + escopo de consultoria ESG',
        valorAdicional: 300_000,
      },
    ],
    status: 'ativo',
  },
  {
    id: 'ctr-4',
    cliente: 'Itau Unibanco',
    numero: '0032',
    periodo: { inicio: '2025-03-01', fim: '2026-02-28' },
    valorLimite: 2_800_000,
    agenciasEnvolvidas: 1,
    formaRemuneracao: 'Success Fee',
    percentuaisRemuneracao: { success: 100 },
    dataRepactuacao: null,
    aditivos: [],
    status: 'ativo',
  },
  {
    id: 'ctr-5',
    cliente: 'Bradesco',
    numero: '0078',
    periodo: { inicio: '2024-06-01', fim: '2025-05-31' },
    valorLimite: 1_900_000,
    agenciasEnvolvidas: 2,
    formaRemuneracao: 'Misto',
    percentuaisRemuneracao: { fee: 60, success: 40 },
    dataRepactuacao: '2025-04-15',
    aditivos: [
      {
        id: 'adit-4',
        numero: '0078-A1',
        data: '2024-12-01',
        descricao: 'Reajuste inflacionario + novo escopo promo',
        valorAdicional: 250_000,
      },
    ],
    status: 'ativo',
  },
  {
    id: 'ctr-6',
    cliente: 'Ambev',
    numero: '0091',
    periodo: { inicio: '2025-09-01', fim: '2026-08-31' },
    valorLimite: 6_200_000,
    agenciasEnvolvidas: 3,
    formaRemuneracao: 'Projeto',
    dataRepactuacao: '2026-06-01',
    aditivos: [],
    status: 'em-negociacao',
  },
  {
    id: 'ctr-7',
    cliente: 'Magazine Luiza',
    numero: '0045',
    periodo: { inicio: '2024-01-01', fim: '2024-12-31' },
    valorLimite: 2_100_000,
    agenciasEnvolvidas: 1,
    formaRemuneracao: 'Fee Mensal',
    percentuaisRemuneracao: { fee: 100 },
    dataRepactuacao: null,
    aditivos: [],
    status: 'encerrado',
  },
  {
    id: 'ctr-8',
    cliente: 'Natura',
    numero: '0067',
    periodo: { inicio: '2024-03-01', fim: '2025-02-28' },
    valorLimite: 1_600_000,
    agenciasEnvolvidas: 2,
    formaRemuneracao: 'Misto',
    percentuaisRemuneracao: { fee: 50, success: 50 },
    dataRepactuacao: null,
    aditivos: [
      {
        id: 'adit-5',
        numero: '0067-A1',
        data: '2024-09-15',
        descricao: 'Campanha de sustentabilidade — escopo adicional',
        valorAdicional: 200_000,
      },
    ],
    status: 'encerrado',
  },
]
